<template>
  <div id="app-curriculum-body" v-if="loaded">
    <!-- 顶栏 -->
    <HeaderMain></HeaderMain>
    <div class="app-body-1160px">
      <!-- 左栏 -->
      <div id="app-curriculum-left">
        <div id="app-curriculum-info">
          <img alt="pic" id="app-curriculum-img" :src="curriculumInfo.curriculumData.coverPhoto"/>
          <el-button id="app-curriculum-start">
            开始学习
          </el-button>
          <h1 id="app-curriculum-name"> {{ curriculumInfo.curriculumData.name }}</h1>
          <p id="app-curriculum-introduce">{{ curriculumInfo.curriculumData.remark }}</p>
        </div>
      </div>
      <!-- 右栏 -->
      <InfoRight :curriculum-info="curriculumInfo"></InfoRight>
    </div>
  </div>
</template>

<script>

import InfoRight from "@/views/practice/curriculum/components/InfoRight";
import AxiosBase from "@/components/axiosBase";
import HeaderMain from "@/views/share/HeaderMain";

export default {
  name: "Curriculum",
  components: {
    HeaderMain,
    InfoRight
  },
  data() {
    return {
      text: '23165487',
      index: 50,
      index2: 4,
      curriculumInfo: {
        curriculumData: {
          name: '',
          coverPhoto: '',
          remark: '',
          collectionTimes: ''
        }
      },
      loaded: false
    }
  },
  beforeMount() {
    if (this.$route.params.id === undefined || this.$route.params.id === '') {
      this.$router.push("/404")
    } else {
      AxiosBase.axiosGet("/curriculum/in", {
        params: {
          id: this.$route.params.id
        }
      }).then(response => {
        if (response === 0) {
          this.$router.push("/404")
        } else {
          this.curriculumInfo = response.data
          this.loaded = true;
        }
      })
    }
    document.title = this.curriculumInfo.curriculumData.name;
  },
}
</script>


<style scoped>

#app-curriculum-body {
  width: 1260px;
  margin: auto;
}

#app-curriculum-left {
  position: relative;
  top: 25px;
  left: 25px;
  width: 250px;
  float: left;
  padding: 10px;
}

#app-curriculum-info {
  width: 100%;
  height: 300px;
}

#app-curriculum-img {
  display: block;
  width: 250px;
  height: 180px;
}

#app-curriculum-start {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 25px;
  border-radius: 0;
  background: #FF8A00;
  color: #FFFFFF
}

#app-curriculum-name {
  font-size: 20px;
  border-bottom: 1px solid rgba(20, 20, 20, 0.4);
  padding-bottom: 10px
}

#app-curriculum-introduce {
  padding-top: 10px;
  font-size: 10px;
  color: rgba(20, 20, 20, 0.7);
  margin-bottom: 10px
}


</style>